module.exports = __webpack_public_path__ + "img/box1_icon4.ce02824a.png";